import adminService from '../service/admin'

const state = {
    users: [],
    loading: false,
    telemetrySources: [],
    telemetry: {
        data: [],
        loading: false
    },
    roles: {
        data: [],
        loading: false
    },
    permissions: {
        data: [],
        loading: false
    },
}

const actions = {
    getPermissions({ commit }) {
        commit('setPermissionLoading', true)
        return adminService.getPermissions().then(permissions => {
            commit('setPermissions', permissions)
        }).catch(() => {
            commit('setPermissionLoading', false)
        })
    },
    getRoles({ commit }) {
        commit('setRolesLoading', true)
        return adminService.getRoles().then(roles => {
            commit('setRoles', roles)
        }).catch(() => {
            commit('setRolesLoading', false)
        })
    },
    createRole({ commit }, role) {
        return adminService.createRole(role).then((_id) => {
            role._id = _id
            commit('addRole', role);
        })
    },
    updateRole({ commit, dispatch }, role) {
        return adminService.updateRole(role).then(() => {
            commit('updateRole', role);
            dispatch("getRoles");
        })
    },
    deleteRole({ commit }, roleName) {
        return adminService.deleteRole(roleName).then(() => {
            commit('deleteRole', roleName);
        })
    },
    getTelemetrySources({ commit }) {
        commit('setTelemetryLoading', true)
        return adminService.getTelemetrySources().then(sources => {
            commit('setTelemetrySources',sources)
        }).catch(() => {
            commit('setTelemetryLoading', false)
        })
    },
    getTelemetry({ commit }) {
        commit('setTelemetryLoading', true)
        return adminService.getTelemetry().then(telemetry => {
            commit('setTelemetry', telemetry)
        }).catch(() => {
            commit('setTelemetryLoading', false)
        })
    },
    updatePreferences({ _ }, preferences) {
        return adminService.updatePreferences(preferences).then(() => {
        })
    },
    createTelemetry({ commit }, telemetry) {
        return adminService.createTelemetry(telemetry).then((_id) => {
            telemetry._id = _id
            commit('addTelemetry', telemetry);
        })
    },
    updateTelemetry({ commit }, telemetry) {
        return adminService.updateTelemetry(telemetry).then(() => {
            commit('updateTelemetry', telemetry);
        })
    },
    deleteTelemetry({ commit }, telemetryName) {
        return adminService.deleteTelemetry(telemetryName).then(() => {
            commit('deleteTelemetry', telemetryName);
        })
    },

    getUsers({ commit }) {
        commit('setLoading', true)
        return adminService.getUsers().then(users => {
            commit('setUsers', users)
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    createUser({ commit }, user) {
        return adminService.createUser(user).then(_id => {
            user._id = _id
            commit('addUser', user);
        })
    },
    updateUser({ commit }, user) {
        return adminService.updateUser(user).then(() => {
            commit('updateUser', user);
        })
    },
    updateTelemetryOrder({dispatch},{telemetries}){
        return adminService.updateTelemetryOrder(telemetries)
        
},
    deleteUser({ commit }, userId) {
        return adminService.deleteUser(userId).then(() => {
            commit('deleteUser', userId);
        })
    }
};
const mutations = {
    setPermissions(state, permissions) {
        state.permissions.data = permissions
        state.permissions.loading = false
    },
    setPermissionLoading(state, loading) {
        state.permissions.loading = loading
    },
    addRole(state, role) {
        state.roles.data.push(role)
    },
    setTelemetrySources(state, sources) {
        state.telemetrySources = sources
    },
    updateRole(state, updatedRole) {
        var role = state.roles.data.find(x => x._id == updatedRole._id)
        if (role) {
            role.name = updatedRole.name;
            role.dashboard = updatedRole.dashboard;
            role.trend = updatedRole.trend;
            role.point = updatedRole.point;
            role.measurement = updatedRole.measurement;
            role.alarm = updatedRole.alarm;
            role.routes = updatedRole.routes;
            role.adminPanel = updatedRole.adminPanel;
        }
    },
    deleteRole(state, roleName) {
        var index = state.roles.data.findIndex(x => x.name == roleName)
        if (index != -1) {
            state.roles.data.splice(index, 1)
        }
    },
    setRoles(state, roles) {
        state.roles.data = roles
        state.roles.loading = false
    },
    setRolesLoading(state, loading) {
        state.roles.loading = loading
    },

    addTelemetry(state, telemetry) {
        state.telemetry.data.push(telemetry)
    },
  
    updateTelemetry(state, updatedTelemetry) {
        var telemetry = state.telemetry.data.find(x => x._id == updatedTelemetry._id)
        if (telemetry) {
            telemetry.unit = updatedTelemetry.unit;
            telemetry.displayName = updatedTelemetry.displayName;
        }
    },
    deleteTelemetry(state, telemetryName) {
        var index = state.telemetry.data.findIndex(x => x.name == telemetryName)
        if (index != -1) {
            state.telemetry.data.splice(index, 1)
        }
    },
    setTelemetry(state, telemetry) {
        state.telemetry.data = telemetry
        state.telemetry.loading = false
    },
    setTelemetryLoading(state, loading) {
        state.telemetry.loading = loading
    },

    setLoading(state, loading) {
        state.loading = loading
    },
    updateUser(state, updatedUser) {
        var user = state.users.find(x => x._id == updatedUser._id)
        if (user) {
            user.name = updatedUser.name;
            user.role = updatedUser.role;
            user.surname = updatedUser.surname;
            user.email = updatedUser.email;
        }
    },
    addUser(state, user) {
        state.users.push(user)
    },
    deleteUser(state, userId) {
        var index = state.users.findIndex(x => x._id == userId)
        if (index != -1) {
            state.users.splice(index, 1)
        }
    },
    setUsers(state, users) {
        state.users = users
        state.loading = false
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
